export default __webpack_public_path__ + "static/media/key_features_supermarkets.cc92c8c2.png";